module.exports = __webpack_public_path__ + "static/media/plant.bfee50fb.svg";